import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { ContactTemplateResponse } from '../../../types/ContactTemplate';

type UseGetAllContactTemplatesParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: {
    archived?: boolean;
  };
};

export type UseGetAllContactTemplatesProps = {
  params?: UseGetAllContactTemplatesParams;
  enabled?: boolean;
};

export const fetchAllContactTemplates = async ({ params }: UseGetAllContactTemplatesProps) => {
  const response = await CustomAxios.get<ContactTemplateResponse>('contact_templates', { params });
  return response.data;
};

export function useGetAllContactTemplates({ params, enabled = true }: UseGetAllContactTemplatesProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.allContactTemplates, params],
    queryFn: () => fetchAllContactTemplates({ params }),
    placeholderData: keepPreviousData,
  });
}
